'use client';

import type { LDClient, LDContext } from 'launchdarkly-js-client-sdk';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

import { initialize as initializeLDClient } from 'launchdarkly-js-client-sdk';

const LaunchDarklyWebContext = createContext<LDClient | null>(null);

const LaunchDarklyWebProvider = ({ children }: PropsWithChildren) => {
  if (typeof window === 'undefined') return <>{children}</>;

  const context: LDContext = {
    kind: 'device',
    anonymous: true,
  };

  const clientSideId =
    process.env['EXPO_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID'] ||
    process.env['NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID'] ||
    '';

  const client = initializeLDClient(clientSideId, context);

  return (
    <LaunchDarklyWebContext.Provider value={client}>
      {children}
    </LaunchDarklyWebContext.Provider>
  );
};

function useLaunchDarklyWebClient() {
  const context = useContext(LaunchDarklyWebContext);

  if (!context) {
    throw new Error(
      'useLaunchDarklyWebClient must be used within a LaunchDarklyWebProvider',
    );
  }

  return context;
}

export { LaunchDarklyWebProvider, useLaunchDarklyWebClient };
